import React from 'react'
import { useIntl } from 'react-intl'
import { useRecoilState } from 'recoil'

import {
  Grid,
  GridCell,
  GRID_VARIANT_VERTICAL_BIG,
  FormElement,
  InputText,
  INPUT_TEXT_VARIANT_DANGER
} from 'mailup-web-components'
import InputTags from './InputTags'

import { abTestState } from '../recoil/state/abTest'

const AbTestInfoOnSheduling = () => {
  const intl = useIntl()
  const [{ Info }, setAbTestState] = useRecoilState(abTestState)

  const onChangeTestName = e => {
    setAbTestState(prev => ({
      ...prev,
      Info: {
        ...prev.Info,
        Nome: e.target.value
      },
      IsDirty: true
    }))
  }

  const onInputTagChange = value => {
    setAbTestState(prev => ({
      ...prev,
      Tags: value,
      IsDirty: true
    }))
  }
  return (
    <Grid
      variantVertical={GRID_VARIANT_VERTICAL_BIG}
      cols={Info.TipoTest === 'X' ? 1 : 2}
    >
      <GridCell>
        <FormElement
          required
          label={intl.formatMessage({ id: 'Load.AbTest.TestName' })}
          feedback={
            !Info.Nome
              ? intl.formatMessage({ id: 'Load.MailupCommon.Required' })
              : undefined
          }
        >
          <InputText
            placeholder={intl.formatMessage({ id: 'Load.AbTest.TestName' })}
            value={Info.Nome}
            onChange={onChangeTestName}
            variant={!Info.Nome ? INPUT_TEXT_VARIANT_DANGER : undefined}
          />
        </FormElement>
      </GridCell>
      {Info.TipoTest !== 'X' && (
        <GridCell>
          <InputTags
            onChange={value => onInputTagChange(value)}
            idDisabled={false}
          />
        </GridCell>
      )}
    </Grid>
  )
}
export default AbTestInfoOnSheduling
